export const version = {version: '7.3.0'}
